<template>
  <div class="login-form-container">
    <div class="login-form">
      <el-form @submit.native.prevent="login">
        <img class="login-logo" src="/assets/images/logo_trr.svg" />
        <el-input v-model="username" v-mask="'+7 (###)###-####'" placeholder="Корп. номер телефона"></el-input>
        <el-input required type="password" v-model="password" placeholder="Пароль от CRM" show-password />
        <el-button :disabled="disableButton" :loading="loading" type="primary" native-type="submit">Войти</el-button>
        <div>
          <strong>{{ texterr }}</strong>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { AUTH_REQUEST } from "@/store/actions/auth"
import axios from 'axios'
import { mapGetters, mapState } from "vuex"

export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      spinner: false,
      showtexterr: false,
      texterr: "",
      loading: false,
      telegramUser: null,
      isTelegramWebApp: false,
      telegramWebApp: null
    }
  },
  created() {
    this.initTelegramApp()
  },
  computed: {
    disableButton() {
      return this.username.length !== 16 || this.password == ""
    },
    ...mapGetters([
      "getProfile",
      "isAuthenticated",
      "isProfileLoaded",
      "isDiler",
    ]),
    ...mapState({
      authLoading: (state) => state.auth.status === "loading",
      name: (state) => `${state.user.profile.name}`,
    }),
  },
  methods: {
    initTelegramApp() {
      if (window.Telegram && window.Telegram.WebApp) {
        this.isTelegramWebApp = true
        this.telegramWebApp = window.Telegram.WebApp
        this.telegramWebApp.ready()
        this.telegramWebApp.expand()
        this.telegramWebApp.setHeaderColor('#ffffff')
        this.telegramWebApp.setBackgroundColor('#ffffff')
        if (this.telegramWebApp.initData) {
          console.log('Login component - найден initData, пытаемся авторизоваться')
          this.authenticateWithTelegram()
        } else {
          console.log('Login component - initData отсутствует, используем стандартную авторизацию')
        }
        if (this.telegramWebApp.initDataUnsafe && this.telegramWebApp.initDataUnsafe.user) {
          this.telegramUser = this.telegramWebApp.initDataUnsafe.user
          console.log('Login component - данные пользователя:', this.telegramUser)
        }
      } else {
        console.log('Login component - Приложение не открыто в Telegram WebApp')
      }
    },
    authenticateWithTelegram() {
      this.loading = true

      axios.post('https://m.liftnet.ru/api/v1/telegram/recreate-crm-token', {
        initData: this.telegramWebApp.initData
      })
        .then(response => {
          console.log('Ответ от сервера аутентификации:', response.data)

          if (response.data && response.data.token_crm) {
            localStorage.setItem("user-token", response.data.token_crm)

            // Сохраняем Telegram ID пользователя, если он доступен
            if (this.telegramUser && this.telegramUser.id) {
              localStorage.setItem("telegram-id", this.telegramUser.id)
              this.$store.commit('updateTelegramId', this.telegramUser.id)
              console.log("Telegram ID сохранен при аутентификации:", this.telegramUser.id)
            }

            this.$store.commit('AUTH_SUCCESS', { token: response.data.token_crm })
            this.$router.push("/task-list/")
          } else {
            this.loading = false
            this.texterr = "Не удалось получить токен авторизации"
            console.error('Ошибка при получении токена:', response)
          }
        })
        .catch(error => {
          this.loading = false
          console.error('Ошибка при аутентификации через Telegram:', error)
          this.texterr = "Ошибка при аутентификации через Telegram"
        })
    },
    login() {
      this.loading = true
      const { username, password } = this
      this.spinner = true
      this.$store
        .dispatch(AUTH_REQUEST, { username, password })
        .then(() => {
          setTimeout(() => {
            if (this.$store.getters.isDiler) {
              this.$router.push("/check-firm/")
            } else {
              this.$router.push("/task-list/")
            }
          }, 200)
        })
        .catch((err) => {
          this.loading = false
          this.$notify.error({
            title: "Ошибка",
            message: err,
          })
        })
    },
    showerressage(err) {
      this.showtexterr = true
      this.texterr = "Ошибка авторизации!!!"
      console.log(err.response.status)
    },
  },
}
</script>

<style scoped lang="scss">
.login-form-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login-form {
  width: 100%;
  max-width: 600px;
}

.login-form * {
  margin: 5px 0;
}

.el-button {
  display: block;
}

.el-form {
  display: flex;
  flex-direction: column;
  align-items: center;

  .el-button {
    width: 90%;
    max-width: 400px;
  }
}

.el-form>div {
  width: 90%;
  max-width: 400px;
}

.login-logo {
  width: 80%;
  max-width: 350px;
  margin-bottom: 30px;
}
</style>